import { ChangeDetectorRef, Component, OnInit, Input } from "@angular/core";
import { LaboursService } from "../labours.service";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { LabourProfileImageComponent } from "../create-sub-labour/labour-profile-image/labour-profile-image.component";
import { SharedService } from "src/app/core/services";
import { GLOBAL } from "src/app/app.globals";
import { GatePassRequestsService } from "../../gate-pass-requests/gate-pass-requests.service";
import { FileDoc, FileUploadService } from "src/app/core/components";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { CommonService } from "src/app/common/common.service";
import { SharedDataService } from "src/app/core/services/shared-data.service";
import { DynamicApicallService } from "src/app/service/dynamic-apicall.service";
import { DataShareService } from "src/app/service/data-share.service";
import { log } from "console";
import { LogHelperService } from "src/app/core/services/log-helper.service";
// import imageCompression from 'browser-image-compression';
export let PHOTO_URL;
const browserWindow = window || {};
const browserWindowEnv = browserWindow["__env"] || {};
PHOTO_URL = browserWindowEnv.PHOTO_URL;
PHOTO_URL = `${PHOTO_URL}`;


@Component({
  selector: "app-upload-photo",
  templateUrl: "./upload-photo.component.html",
  styleUrls: ["./upload-photo.component.css"],
})
export class UploadPhotoComponent implements OnInit {
  showModal: boolean = false;
  @Input() labourData: any;

  uploadedFiles: FileDoc[] = [];
  copyUploadedFiles: FileDoc[] = [];
  public unitDepartmentSectionTreeData: any[] = [];
  public allowedFileTypes: any = GLOBAL.ALLOWED_FILE_TYPES;
  public maxSizeAllowed: any = "";
  documentTypes = [];
  globalSettings: any;

  selectedLabour: any;

  leftFinger: string = "";
  rightFinger: string = "";
  fingers: string[] = ["Thumb", "Index", "Middle", "Ring", "Pinky"];
  labourForm: FormGroup;

  leftHandData: any = {
    Thumb: null,
    Index: null,
    Middle: null,
    Ring: null,
    Pinky: null,
  };

  rightHandData: any = {
    Thumb: null,
    Index: null,
    Middle: null,
    Ring: null,
    Pinky: null,
  };

  photoFile: File | null = null;
  leftFingerFile: File | null = null;
  rightFingerFile: File | null = null;
  originalLabour: any;
  leftFingerImage: string = "";
  rightFingerImage: string = "";
  savedCroppedImage: string = "../assets/Image/Icon/default.png";

  labourDemandTypes: { Id: number; Name: string }[];
  skillTypes: any;
  wagecriteria: { Id: number; Name: string }[];
  companyData: any = [];
  plants: any = [];
  units: any = [];
  sectionData: any = [];
  sectionData1: any = [];
  sectionData2: any = [];
  section1;
  section2;
  section3;
  departmentData: any = [];
  workSites: any = [];
  workCategory: any = [];
  workmanCategory: any = [];
  validityperiod: any = [];
  yesNoData1: any = [];
  yesNoData2: any = [];
  masterData: any = [];

  plantList: any = [];
  unitList: any = [];
  departmentList: any = [];
  sectionList: any = [];
  section1List: any = [];
  section2List: any = [];

  selectedWorkSite: any = [];
  matchedWorkSites: any = [];
  selectedValidity: any = [];
  matchedValidityPeriod: any = [];
  public sectionTreeList: any[] = [];

  constructor(
    private labourService: LaboursService,
    private logHelperService: LogHelperService,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    public sharedService: SharedService,
    private cdRef: ChangeDetectorRef,
    public commonService: CommonService,
    private apiCall: DynamicApicallService,
    private gatePassRequestsService: GatePassRequestsService,
    public sharedDataService: SharedDataService,
    public dataShareService: DataShareService,
    private fileUploadService: FileUploadService
  ) { }

  ngOnInit(): void {
    this.showModal = true;
    this.getDepartmentPlantUnitSectionData();
    this.getDocumentTypes();
    this.initializeForm();
    this.getCompanyData();

    this.commonService.getJobTypes().subscribe((res: any) => {
      this.labourDemandTypes = res[0].Values;
    });
    this.labourService.getSkillType().subscribe((response: any) => {
      this.skillTypes = response;
    });

    this.wagecriteria = [
      { Id: 1, Name: "Wage / Salary < 21000.00" },
      { Id: 0, Name: "Wage / Salary ≥ 21000.00" },
    ];

    const formControls = {
      JoiningDate: null,
      IssueDate: null,
      ValidUptoDate: null,
      LabourDemandTypeMasterItem_Code: null,
      Skill_Code: null,
      OldGatePassNo: null,
      ESICWageCriteria: null,
      Company: null,
      Plant_Code: null,
      Unit_Code: null,
      department: null,
      Section_Code: null,
      Section_Code1: null,
      Section_Code2: null,
      WorksiteMasterItemList_Code: null,
      WorkCategoryMIT_Code: null,
      CategoryMIL_Code: null,
      ValidityPeriod_Code: null,
    };

    const formGroup = {};
    Object.keys(formControls).forEach((key) => {
      formGroup[key] = new FormControl(formControls[key]);
    });

    this.globalSettings = this.dataShareService.globalCodesArrayDataShareService;
    this.maxSizeAllowed =
      Number(
        this.globalSettings.find((item) => item.Code === "DOCSIZEL1").Value
      ) * 1024;
    this.allowedFileTypes = this.globalSettings.find(
      (item) => item.Code === "DOCFORMATL1"
    ).Value;

    this.sharedDataService.getMasterData().subscribe((masterList: any) => {
      if (masterList && masterList.Data && masterList.Data.Table.length > 0) {
        this.masterData = masterList.Data.Table;

        this.workSites = this.masterData.filter(
          (list) => list.Parent_Code === 612
        );

        this.workCategory = this.masterData.filter(
          (list) => list.Parent_Code === 618
        );
        this.workmanCategory = this.masterData.filter(
          (list) => list.Parent_Code === 858
        );
        this.validityperiod = this.masterData.filter(
          (list) => list.Parent_Code === 875
        );
      }
    });
  }

  // compressedImage: string | ArrayBuffer | null = null;
  // async selectImage(event: any) {
  //   const file = event.target.files[0];
  //   if (!file) return;

  //   const options = {
  //     maxSizeMB: 0.2, // Max size 200KB
  //     maxWidthOrHeight: 800, // Max width/height
  //     useWebWorker: true,
  //   };

  //   try {
  //     const compressedFile = await imageCompression(file, options);
  //     const reader = new FileReader();
  //     reader.readAsDataURL(compressedFile);
  //     reader.onload = () => {
  //       this.compressedImage = reader.result;
  //     };
  //   } catch (error) {
  //     console.error('Error compressing image:', error);
  //   }
  // }

  getCompanyData() {
    return this.labourService.getCompanyData().subscribe((res: any) => {
      this.companyData = res.Data.Table;
      if (this.companyData.length === 1) {
        this.labourForm.controls["Company"].setValue(
          this.companyData[0].Company_Code
        );
      } else {
        this.companyData = res.Data.Table;
      }
    });
  }

  private initializeForm(): void {
    this.labourForm = this.formBuilder.group({
      JoiningDate: ["", Validators.required],
      IssueDate: ["", Validators.required],
      ValidUptoDate: ["", Validators.required],
      LabourDemandTypeMasterItem_Code: ["", Validators.required],
      Skill_Code: ["", Validators.required],
      OldGatePassNo: [""],
      ESICWageCriteria: ["", Validators.required],
      Company: ["", Validators.required],
      Plant_Code: ["", Validators.required],
      Unit_Code: ["", Validators.required],
      department: ["", Validators.required],
      Section_Code: ["", Validators.required],
      Section_Code1: ["", Validators.required],
      Section_Code2: ["", Validators.required],
      WorksiteMasterItemList_Code: ["", Validators.required],
      WorkCategoryMIT_Code: ["", Validators.required],
      CategoryMIL_Code: ["", Validators.required],
      ValidityPeriod_Code: [""],
      leftFinger: [""],
      rightFinger: [""],
    });
  }

  public onCompanyChange(): void {
    this.plants = [];
    this.units = [];
    this.departmentData = [];
    this.sectionData = [];
    this.sectionData1 = [];
    this.sectionData2 = [];
    this.sectionTreeList = [];
  }

  getDepartmentPlantUnitSectionData() {
    this.labourService.getDepartmentPlantUnitSectionData().subscribe((response: any[]) => {
      this.sectionTreeList = response;

      this.plantList = response.map(plant => ({
        Plant_Code: plant.Plantcode0,
        name: plant.Plant0
      }));

      this.getSingleLabour(this.labourData);
    }, error => {
      console.error("Error fetching data:", error);
    });
  }

  onPlantChange(selectedPlant) {
    this.unitList = [];
    this.departmentList = [];
    this.sectionList = [];
    this.section1List = [];
    this.section2List = [];

    this.labourForm.controls["Unit_Code"].setValue(null);
    this.labourForm.controls["department"].setValue(null);
    this.labourForm.controls["Section_Code"].setValue(null);
    this.labourForm.controls["Section_Code1"].setValue(null);
    this.labourForm.controls["Section_Code2"].setValue(null);

    let selectedPlants = this.sectionTreeList.filter(plant => plant.Plantcode0 == selectedPlant.Plant_Code);

    this.unitList = selectedPlants.reduce((acc, plant) => acc.concat(plant.Values.map(unit => ({
      Unitcode0: unit.Unitcode0,
      name: unit.Unit0
    }))), []);

    if (this.unitList.length === 1) {
      let obj = {
        Unitcode0: this.unitList[0].Unitcode0
      }
      this.onUnitChange(obj);
    }
  }

  onUnitChange(selectedUnit) {

    this.departmentList = [];
    this.sectionList = [];
    this.section1List = [];
    this.section2List = [];

    this.labourForm.controls["department"].setValue(null);
    this.labourForm.controls["Section_Code"].setValue(null);
    this.labourForm.controls["Section_Code1"].setValue(null);
    this.labourForm.controls["Section_Code2"].setValue(null);

    let selectedUnits = this.sectionTreeList.reduce((acc, plant) => acc.concat(plant.Values), []).filter(unit => unit.Unitcode0 == selectedUnit.Unitcode0);

    this.departmentList = selectedUnits.reduce((acc, unit) => acc.concat(unit.Values.map(dept => ({
      Departmentcode0: dept.Departmentcode0,
      name: dept.Department0
    }))), []);

    if (this.departmentList.length === 1) {
      let obj = {
        Departmentcode0: this.departmentList[0].Departmentcode0
      }
      // this.labourForm.controls["department"].setValue(this.departmentList[0].Departmentcode0);
      this.onDepartmentChange(obj);
    }
  }

  onDepartmentChange(selectedDepartment) {

    this.sectionList = [];
    this.section1List = [];
    this.section2List = [];

    this.labourForm.controls["Section_Code"].setValue(null);
    this.labourForm.controls["Section_Code1"].setValue(null);
    this.labourForm.controls["Section_Code2"].setValue(null);

    let selectedDepartments = this.sectionTreeList
      .reduce((acc, plant) => acc.concat(plant.Values), [])
      .reduce((acc, unit) => acc.concat(unit.Values), [])
      .filter(dept => dept.Departmentcode0 == selectedDepartment.Departmentcode0);

    this.sectionList = selectedDepartments.reduce((acc, dept) => acc.concat(dept.Values.map(sec => ({
      Sectioncode0: sec.Sectioncode0,
      name: sec.SectionName0
    }))), []);

    if (this.sectionList.length === 1) {
      let obj = {
        Sectioncode0: this.sectionList[0].Sectioncode0
      }
      // this.labourForm.controls["Section_Code"].setValue(this.sectionList[0].Sectioncode0);
      this.onSectionDataChange(obj);
    }
  }

  onSectionDataChange(selectedSection) {

    this.section1List = [];
    this.section2List = [];

    this.labourForm.controls["Section_Code1"].setValue(null);
    this.labourForm.controls["Section_Code2"].setValue(null);

    let selectedSections = this.sectionTreeList
      .reduce((acc, plant) => acc.concat(plant.Values), [])
      .reduce((acc, unit) => acc.concat(unit.Values), [])
      .reduce((acc, dept) => acc.concat(dept.Values), [])
      .filter(sec => sec.Sectioncode0 == selectedSection.Sectioncode0);

    this.section1List = selectedSections.reduce((acc, sec) => acc.concat(sec.Values.map(sec1 => ({
      Sectioncode1: sec1.Sectioncode1,
      name: sec1.SectionName1
    }))), []);

    if (this.section1List.length === 1) {
      let obj = {
        Sectioncode1: this.section1List[0].Sectioncode1
      }
      // this.labourForm.controls["Section_Code1"].setValue(this.section1List[0].Sectioncode1);
      this.onSectionData1Change(obj);
    }
  }

  onSectionData1Change(selectedSectio1) {

    this.section2List = [];
    this.labourForm.controls["Section_Code2"].setValue(null);

    let selectedSection1s = this.sectionTreeList
      .reduce((acc, plant) => acc.concat(plant.Values), [])
      .reduce((acc, unit) => acc.concat(unit.Values), [])
      .reduce((acc, dept) => acc.concat(dept.Values), [])
      .reduce((acc, sec) => acc.concat(sec.Values), [])
      .filter(sec1 => sec1.Sectioncode1 == selectedSectio1.Sectioncode1);

    this.section2List = selectedSection1s.reduce((acc, sec1) => acc.concat(sec1.Values.map(sec2 => ({
      Sectioncode2: sec2.Sectioncode2,
      name: sec2.SectionName2
    }))), []);

    if (this.section2List.length === 1) {
      // this.labourForm.controls["Section_Code2"].setValue(this.section2List[0].Sectioncode2);
    }
  }

  getDocumentTypes() {
    const res = {
      Page_Code: 196,
      RequireType: 1,
      ActionType: 0,
      UserId: GLOBAL.USER_ID,
      Search: null,
      SelectedField: "Name,DocumentType_Code,page_code",
    };
    this.gatePassRequestsService.getDocumentTypesPageModuleWise(res).subscribe((docTypes: any) => {
      this.documentTypes = docTypes;
    });
  }

  getSingleLabour(labourData: any): void {
    const reqObj = {
      Filter: {
        Labour_Code: labourData.Labour_Code,
        request_Code: labourData.Request_Code,
        RequireType: 0,
        ActionType: 0,
        UserId: GLOBAL.USER_ID,
      }
    };
console.log('====================================');
    console.log("Requested object for sp",reqObj);
    console.log('====================================');
    this.apiCall.callApi('Common/MultiTableList/CLPMS_GET_LabourInfo', 'POST', { body: reqObj }).subscribe((response) => {
     console.log('====================================');
     console.log("Response CLPMS_GET_LabourInfo",response);
     console.log('====================================');
      if (response) {
        this.selectedLabour = response.Table1[0];
        this.selectedWorkSite = response.Table2;
        this.selectedValidity = response.Table3;

        this.originalLabour = {
      ...response.Table1[0],
      Photo: null,
      Photo_ID: null,
      Photo_CreatedDate: null,
      Photo_CreateBy: null,
      Photo_ModifiedDate: null,
      Photo_ModifiedBy: null,
      
      LeftThumb: null,
      LeftThumb_ID: null,
      LeftThumb_CreatedDate: null,
      LeftThumb_CreateBy: null,
      LeftThumb_ModifiedDate: null,
      LeftThumb_ModifiedBy: null,
      
      LeftIndex: null,
      LeftIndex_ID: null,
      LeftIndex_CreatedDate: null,
      LeftIndex_CreateBy: null,
      LeftIndex_ModifiedDate: null,
      LeftIndex_ModifiedBy: null,
      
      LeftMiddle: null,
      LeftMiddle_ID: null,
      LeftMiddle_CreatedDate: null,
      LeftMiddle_CreateBy: null,
      LeftMiddle_ModifiedDate: null,
      LeftMiddle_ModifiedBy: null,
      
      LeftRing: null,
      LeftRing_ID: null,
      LeftRing_CreatedDate: null,
      LeftRing_CreateBy: null,
      LeftRing_ModifiedDate: null,
      LeftRing_ModifiedBy: null,
      
      LeftPinky: null,
      LeftPinky_ID: null,
      LeftPinky_CreatedDate: null,
      LeftPinky_CreateBy: null,
      LeftPinky_ModifiedDate: null,
      LeftPinky_ModifiedBy: null,
      
      RightThumb: null,
      RightThumb_ID: null,
      RightThumb_CreatedDate: null,
      RightThumb_CreateBy: null,
      RightThumb_ModifiedDate: null,
      RightThumb_ModifiedBy: null,
      
      RightIndex: null,
      RightIndex_ID: null,
      RightIndex_CreatedDate: null,
      RightIndex_CreateBy: null,
      RightIndex_ModifiedDate: null,
      RightIndex_ModifiedBy: null,
      
      RightMiddle: null,
      RightMiddle_ID: null,
      RightMiddle_CreatedDate: null,
      RightMiddle_CreateBy: null,
      RightMiddle_ModifiedDate: null,
      RightMiddle_ModifiedBy: null,
      
      RightRing: null,
      RightRing_ID: null,
      RightRing_CreatedDate: null,
      RightRing_CreateBy: null,
      RightRing_ModifiedDate: null,
      RightRing_ModifiedBy: null,
      
      RightPinky: null,
      RightPinky_ID: null,
      RightPinky_CreatedDate: null,
      RightPinky_CreateBy: null,
      RightPinky_ModifiedDate: null,
      RightPinky_ModifiedBy: null,
    };
        // response.Table4.forEach((file) => {
        //   const fileName = file.UploadFileName.split("_").slice(1).join("_");
        //   this.uploadedFiles.push({
        //     ID: file.ID,
        //     file: {
        //       lastModified: file.ModifiedDate,
        //       name: fileName,
        //     },
        //     documentTypeCode: file.DocumentTypeMasterList_Code,
        //     isUploaded: true,
        //     url: GLOBAL.BASE_URL_DOC + file.ParentRootFolder,
        //   });
        // });
        response.Table4.forEach(file => {
      const normalizedPath = file.ParentRootFolder.replace(/\\/g, "/");
      const fileUrl = GLOBAL.BASE_URL_DOC + "/" + normalizedPath + file.UploadFileName;

      // Photo
      if (file.UploadFileName.includes("Photo")) {
        this.savedCroppedImage = fileUrl;
        this.originalLabour.Photo = fileUrl;
        this.originalLabour.Photo_ID = file.ID;
        this.originalLabour.Photo_CreatedDate = file.CreatedDate;
        this.originalLabour.Photo_CreateBy = file.CreateBy;
        this.originalLabour.Photo_ModifiedDate = file.ModifiedDate;
        this.originalLabour.Photo_ModifiedBy = file.ModifiedBy;
      }

      // Left Hand Fingers
      if (file.UploadFileName.includes("LeftThumb")) {
        this.leftHandData.Thumb = fileUrl;
        this.originalLabour.LeftThumb = fileUrl;
        this.originalLabour.LeftThumb_ID = file.ID;
        this.originalLabour.LeftThumb_CreatedDate = file.CreatedDate;
        this.originalLabour.LeftThumb_CreateBy = file.CreateBy;
        this.originalLabour.LeftThumb_ModifiedDate = file.ModifiedDate;
        this.originalLabour.LeftThumb_ModifiedBy = file.ModifiedBy;
      }
      
      if (file.UploadFileName.includes("LeftIndex")) {
        this.leftHandData.Index = fileUrl;
        this.originalLabour.LeftIndex = fileUrl;
        this.originalLabour.LeftIndex_ID = file.ID;
        this.originalLabour.LeftIndex_CreatedDate = file.CreatedDate;
        this.originalLabour.LeftIndex_CreateBy = file.CreateBy;
        this.originalLabour.LeftIndex_ModifiedDate = file.ModifiedDate;
        this.originalLabour.LeftIndex_ModifiedBy = file.ModifiedBy;
      }
      
      if (file.UploadFileName.includes("LeftMiddle")) {
        this.leftHandData.Middle = fileUrl;
        this.originalLabour.LeftMiddle = fileUrl;
        this.originalLabour.LeftMiddle_ID = file.ID;
        this.originalLabour.LeftMiddle_CreatedDate = file.CreatedDate;
        this.originalLabour.LeftMiddle_CreateBy = file.CreateBy;
        this.originalLabour.LeftMiddle_ModifiedDate = file.ModifiedDate;
        this.originalLabour.LeftMiddle_ModifiedBy = file.ModifiedBy;
      }
      
      if (file.UploadFileName.includes("LeftRing")) {
        this.leftHandData.Ring = fileUrl;
        this.originalLabour.LeftRing = fileUrl;
        this.originalLabour.LeftRing_ID = file.ID;
        this.originalLabour.LeftRing_CreatedDate = file.CreatedDate;
        this.originalLabour.LeftRing_CreateBy = file.CreateBy;
        this.originalLabour.LeftRing_ModifiedDate = file.ModifiedDate;
        this.originalLabour.LeftRing_ModifiedBy = file.ModifiedBy;
      }
      
      if (file.UploadFileName.includes("LeftPinky")) {
        this.leftHandData.Pinky = fileUrl;
        this.originalLabour.LeftPinky = fileUrl;
        this.originalLabour.LeftPinky_ID = file.ID;
        this.originalLabour.LeftPinky_CreatedDate = file.CreatedDate;
        this.originalLabour.LeftPinky_CreateBy = file.CreateBy;
        this.originalLabour.LeftPinky_ModifiedDate = file.ModifiedDate;
        this.originalLabour.LeftPinky_ModifiedBy = file.ModifiedBy;
      }

      // Right Hand Fingers
      if (file.UploadFileName.includes("RightThumb")) {
        this.rightHandData.Thumb = fileUrl;
        this.originalLabour.RightThumb = fileUrl;
        this.originalLabour.RightThumb_ID = file.ID;
        this.originalLabour.RightThumb_CreatedDate = file.CreatedDate;
        this.originalLabour.RightThumb_CreateBy = file.CreateBy;
        this.originalLabour.RightThumb_ModifiedDate = file.ModifiedDate;
        this.originalLabour.RightThumb_ModifiedBy = file.ModifiedBy;
      }
      
      if (file.UploadFileName.includes("RightIndex")) {
        this.rightHandData.Index = fileUrl;
        this.originalLabour.RightIndex = fileUrl;
        this.originalLabour.RightIndex_ID = file.ID;
        this.originalLabour.RightIndex_CreatedDate = file.CreatedDate;
        this.originalLabour.RightIndex_CreateBy = file.CreateBy;
        this.originalLabour.RightIndex_ModifiedDate = file.ModifiedDate;
        this.originalLabour.RightIndex_ModifiedBy = file.ModifiedBy;
      }
      
      if (file.UploadFileName.includes("RightMiddle")) {
        this.rightHandData.Middle = fileUrl;
        this.originalLabour.RightMiddle = fileUrl;
        this.originalLabour.RightMiddle_ID = file.ID;
        this.originalLabour.RightMiddle_CreatedDate = file.CreatedDate;
        this.originalLabour.RightMiddle_CreateBy = file.CreateBy;
        this.originalLabour.RightMiddle_ModifiedDate = file.ModifiedDate;
        this.originalLabour.RightMiddle_ModifiedBy = file.ModifiedBy;
      }
      
      if (file.UploadFileName.includes("RightRing")) {
        this.rightHandData.Ring = fileUrl;
        this.originalLabour.RightRing = fileUrl;
        this.originalLabour.RightRing_ID = file.ID;
        this.originalLabour.RightRing_CreatedDate = file.CreatedDate;
        this.originalLabour.RightRing_CreateBy = file.CreateBy;
        this.originalLabour.RightRing_ModifiedDate = file.ModifiedDate;
        this.originalLabour.RightRing_ModifiedBy = file.ModifiedBy;
      }
      
      if (file.UploadFileName.includes("RightPinky")) {
        this.rightHandData.Pinky = fileUrl;
        this.originalLabour.RightPinky = fileUrl;
        this.originalLabour.RightPinky_ID = file.ID;
        this.originalLabour.RightPinky_CreatedDate = file.CreatedDate;
        this.originalLabour.RightPinky_CreateBy = file.CreateBy;
        this.originalLabour.RightPinky_ModifiedDate = file.ModifiedDate;
        this.originalLabour.RightPinky_ModifiedBy = file.ModifiedBy;
      }
    });
        // this.originalLabour = { ...response.Table1[0] };
        // this.originalLabour = {
        //   ...response.Table1[0],

        //   Photo_ID: response.Table1[0].Photo_ID,
        //   LeftThumb_ID: response.Table1[0].LeftThumb_ID,
        //   LeftIndex_ID: response.Table1[0].LeftIndex_ID,
        //   LeftMiddle_ID: response.Table1[0].LeftMiddle_ID,
        //   LeftRing_ID: response.Table1[0].LeftRing_ID,
        //   LeftPinky_ID: response.Table1[0].LeftPinky_ID,

        //   RightThumb_ID: response.Table1[0].RightThumb_ID,
        //   RightIndex_ID: response.Table1[0].RightIndex_ID,
        //   RightMiddle_ID: response.Table1[0].RightMiddle_ID,
        //   RightRing_ID: response.Table1[0].RightRing_ID,
        //   RightPinky_ID: response.Table1[0].RightPinky_ID,
        // };
       
        const fieldsToSet = {
          JoiningDate: this.selectedLabour.JoiningDate,
          IssueDate: this.selectedLabour.IssueDate,
          ValidUptoDate: this.selectedLabour.ValidUptoDate,
          LabourDemandTypeMasterItem_Code: this.selectedLabour.LabourDemandTypeMasterItem_Code,
          Skill_Code: this.selectedLabour.Skill_Code,
          OldGatePassNo: this.selectedLabour.OldGatePassNo,
          ESICWageCriteria: this.selectedLabour.ESICWageCriteria == true ? 1 : 0,
          Plant_Code: this.selectedLabour.Plant_Code,
          Unit_Code: this.selectedLabour.Unitcode0,
          department: this.selectedLabour.Departmentcode0,
          Section_Code: this.selectedLabour.Sectioncode0,
          Section_Code1: this.selectedLabour.Sectioncode1,
          Section_Code2: this.selectedLabour.Sectioncode2,
          CategoryMIL_Code: this.selectedLabour.CategoryMIL_Code,
          WorkCategoryMIT_Code: this.selectedLabour.WorkCategoryMIT_Code,
          WorksiteMasterItemList_Code: Number(this.selectedLabour.WorkSite.split(", ")[0]),
          ValidityPeriod_Code: Number(this.selectedLabour.ValidityPeriord.split(", ")[0]),
        };

        Object.keys(fieldsToSet).forEach(key => {
          if (fieldsToSet[key] !== null && fieldsToSet[key] !== undefined && fieldsToSet[key] !== "") {
            this.labourForm.controls[key].setValue(fieldsToSet[key]);
          }
        });

        if (this.selectedLabour.Plant_Code) {
          let plant = {
            Plant_Code: this.selectedLabour.Plant_Code
          }
          this.labourForm.controls["Plant_Code"].setValue(this.selectedLabour.Plant_Code);
          this.onPlantChange(plant)
        }

        if (this.selectedLabour.Plant_Code && this.selectedLabour.Unitcode0) {
          let unit = {
            Unitcode0: this.selectedLabour.Unitcode0
          }
          this.labourForm.controls["Unit_Code"].setValue(this.selectedLabour.Unitcode0);
          this.onUnitChange(unit)
        }

        if (this.selectedLabour.Plant_Code && this.selectedLabour.Unitcode0 && this.selectedLabour.Departmentcode0) {
          let dept = {
            Departmentcode0: this.selectedLabour.Departmentcode0
          }
          this.labourForm.controls["department"].setValue(this.selectedLabour.Departmentcode0);
          this.onDepartmentChange(dept)
        }

        if (this.selectedLabour.Plant_Code && this.selectedLabour.Unitcode0 && this.selectedLabour.Departmentcode0 && this.selectedLabour.Sectioncode0) {
          let sec = {
            Sectioncode0: this.selectedLabour.Sectioncode0
          }
          this.labourForm.controls["Section_Code"].setValue(this.selectedLabour.Sectioncode0);
          this.onSectionDataChange(sec)
        }

        if (this.selectedLabour.Plant_Code && this.selectedLabour.Unitcode0 && this.selectedLabour.Departmentcode0 && this.selectedLabour.Sectioncode0 && this.selectedLabour.Sectioncode1) {
          let sec1 = {
            Sectioncode1: this.selectedLabour.Sectioncode1
          }
          this.labourForm.controls["Section_Code1"].setValue(this.selectedLabour.Sectioncode1);
          this.onSectionData1Change(sec1)
        }
        if (this.selectedLabour.Plant_Code && this.selectedLabour.Unitcode0 && this.selectedLabour.Departmentcode0 && this.selectedLabour.Sectioncode0 && this.selectedLabour.Sectioncode1) {
          let sec1 = {
            Sectioncode1: this.selectedLabour.Sectioncode1
          }
          this.labourForm.controls["Section_Code1"].setValue(this.selectedLabour.Sectioncode1);
          this.onSectionData1Change(sec1)
        }
        if (this.selectedLabour.Plant_Code && this.selectedLabour.Unitcode0 && this.selectedLabour.Departmentcode0 && this.selectedLabour.Sectioncode0 && this.selectedLabour.Sectioncode1 && this.selectedLabour.Sectioncode2) {
          this.labourForm.controls["Section_Code2"].setValue(this.selectedLabour.Sectioncode2);
        }

        this.savedCroppedImage = this.selectedLabour.Photo || "../assets/Image/Icon/default.png";

        if (this.selectedLabour.Photo) {
          var photourl = `${PHOTO_URL}${this.selectedLabour.Photo}`
          this.savedCroppedImage = photourl;
        } else {
          this.savedCroppedImage = "/assets/Image/Icon/default.png";
        }
        // this.leftHandData = {
        //   Thumb: this.selectedLabour.LeftThumb,
        //   Index: this.selectedLabour.LeftIndex,
        //   Middle: this.selectedLabour.LeftMiddle,
        //   Ring: this.selectedLabour.LeftRing,
        //   Pinky: this.selectedLabour.LeftPinky,
        // };

        // this.rightHandData = {
        //   Thumb: this.selectedLabour.RightThumb,
        //   Index: this.selectedLabour.RightIndex,
        //   Middle: this.selectedLabour.RightMiddle,
        //   Ring: this.selectedLabour.RightRing,
        //   Pinky: this.selectedLabour.RightPinky,
        // };

        this.leftFinger = this.detectFirstAvailableFinger(this.leftHandData);
        this.rightFinger = this.detectFirstAvailableFinger(this.rightHandData);

        // Set initial images
        this.leftFingerImage = this.leftHandData[this.leftFinger] || "../assets/Image/Icon/default_finger.png";
        this.rightFingerImage = this.rightHandData[this.rightFinger] || "../assets/Image/Icon/default_finger.png";

        // Set form values for the initial fingers
        if (this.leftFinger) {
          this.labourForm.controls["leftFinger"].setValue(this.leftFinger);
        }
        if (this.rightFinger) {
          this.labourForm.controls["rightFinger"].setValue(this.rightFinger);
        }
      }
    });

    this.cdRef.detectChanges();

  }

  detectFirstAvailableFinger(handData: any): string {
    for (const finger of this.fingers) {
      if (handData[finger]) {
        return finger;
      }
    }
    return "";
  }

  captureImage(type: string): void {
    const modalRef = this.modalService.open(LabourProfileImageComponent, {
      size: "lg",
      backdrop: "static", windowClass: 'modal-scrollbar-hide'
    });

    const selectedImage = type === "photo" ? this.savedCroppedImage
      : type === "left" && this.leftFinger !== undefined ? this.leftHandData[this.leftFinger]
        : type === "right" && this.rightFinger !== undefined ? this.rightHandData[this.rightFinger]
          : null;

    modalRef.componentInstance.image = selectedImage;
    modalRef.componentInstance.croppedImage.subscribe((arg: any) => {

      if (type === "photo") {
        this.savedCroppedImage = arg;
        this.selectedLabour.Photo = arg;
      } else if (type === "left" && this.leftFinger !== undefined) {
        this.leftFingerImage = arg;
        this.leftHandData[this.leftFinger] = arg;
        this.selectedLabour[`Left${this.leftFinger}`] = arg;
      } else if (type === "right" && this.rightFinger !== undefined) {
        this.rightFingerImage = arg;
        this.rightHandData[this.rightFinger] = arg;
        this.selectedLabour[`Right${this.rightFinger}`] = arg;
      }
    });
  }

  clearImageValues(): void {
    this.savedCroppedImage = "";
    this.leftFingerImage = "";
    this.rightFingerImage = "";
    this.uploadedFiles = [];
  }

  onFingerSelect(hand: string, selectedFinger: string): void {
    if (hand === "left") {
      this.leftFinger = selectedFinger;
      // Get the image for the selected finger or show default
      this.leftFingerImage = this.leftHandData[selectedFinger] || "../assets/Image/Icon/default_finger.png";
    } 
    else if (hand === "right") {
      this.rightFinger = selectedFinger;
      // Get the image for the selected finger or show default
      this.rightFingerImage = this.rightHandData[selectedFinger] || "../assets/Image/Icon/default_finger.png";
    }
    
    // Trigger change detection
    this.cdRef.detectChanges();
  }

  onFileChange(event: Event, type: "photo" | "left" | "right"): void {
    const input = event.target as HTMLInputElement;
    if (input && input.files && input.files[0]) {
      const file = input.files[0];

      this.convertToBase64(file, (base64Image: string) => {
        if (type === "photo") {
          this.savedCroppedImage = base64Image;
        } else if (type === "left") {
          this.leftFingerImage = base64Image;
          this.updateSelectedFingerData("Left", base64Image);
        } else if (type === "right") {
          this.rightFingerImage = base64Image;
          this.updateSelectedFingerData("Right", base64Image);
        }
      });
    }
  }

  convertToBase64(file: File, callback: (base64Image: string) => void): void {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      callback(reader.result as string);
    };
  }

  updateSelectedFingerData(hand: "Left" | "Right", base64Image: string): void {
    const selectedFinger = this[`${hand.toLowerCase()}Finger`];
    if (selectedFinger) {
      const fingerKey = `${hand}${selectedFinger}`;
      if (hand === "Left") {
        this.leftHandData[fingerKey] = base64Image;
      } else if (hand === "Right") {
        this.rightHandData[fingerKey] = base64Image;
      }
    }
  }

  updateDetails(): void {
    const foreignKey = "29BA8F92-E774-45D6-A07C-975827F49171";

    const payload: any = {
      [foreignKey]: {
        Labour_Code: {
          OldValue: this.originalLabour.Labour_Code,
          NewValue: this.selectedLabour.Labour_Code,
        }
      }
    };

    const fieldsToCompare = [
  // {
  //   key: "Photo",
  //   oldValue: this.originalLabour.Photo,
  //   newValue: this.savedCroppedImage,
  //   id: this.originalLabour.Photo_ID,
  //   CreatedDate: this.originalLabour.Photo_CreatedDate,
  //   CreateBy: this.originalLabour.Photo_CreateBy,
  //   ModifiedDate: this.originalLabour.Photo_ModifiedDate,
  //   ModifiedBy: this.originalLabour.Photo_ModifiedBy
  // },
  {
    key: "LeftThumb",
    oldValue: this.originalLabour.LeftThumb,
    newValue: this.leftHandData.Thumb,
    id: this.originalLabour.LeftThumb_ID,
    CreatedDate: this.originalLabour.LeftThumb_CreatedDate,
    CreateBy: this.originalLabour.LeftThumb_CreateBy,
    ModifiedDate: this.originalLabour.LeftThumb_ModifiedDate,
    ModifiedBy: this.originalLabour.LeftThumb_ModifiedBy
  },
  {
    key: "LeftIndex",
    oldValue: this.originalLabour.LeftIndex,
    newValue: this.leftHandData.Index,
    id: this.originalLabour.LeftIndex_ID,
    CreatedDate: this.originalLabour.LeftIndex_CreatedDate,
    CreateBy: this.originalLabour.LeftIndex_CreateBy,
    ModifiedDate: this.originalLabour.LeftIndex_ModifiedDate,
    ModifiedBy: this.originalLabour.LeftIndex_ModifiedBy
  },
  {
    key: "LeftMiddle",
    oldValue: this.originalLabour.LeftMiddle,
    newValue: this.leftHandData.Middle,
    id: this.originalLabour.LeftMiddle_ID,
    CreatedDate: this.originalLabour.LeftMiddle_CreatedDate,
    CreateBy: this.originalLabour.LeftMiddle_CreateBy,
    ModifiedDate: this.originalLabour.LeftMiddle_ModifiedDate,
    ModifiedBy: this.originalLabour.LeftMiddle_ModifiedBy
  },
  {
    key: "LeftRing",
    oldValue: this.originalLabour.LeftRing,
    newValue: this.leftHandData.Ring,
    id: this.originalLabour.LeftRing_ID,
    CreatedDate: this.originalLabour.LeftRing_CreatedDate,
    CreateBy: this.originalLabour.LeftRing_CreateBy,
    ModifiedDate: this.originalLabour.LeftRing_ModifiedDate,
    ModifiedBy: this.originalLabour.LeftRing_ModifiedBy
  },
  {
    key: "LeftPinky",
    oldValue: this.originalLabour.LeftPinky,
    newValue: this.leftHandData.Pinky,
    id: this.originalLabour.LeftPinky_ID,
    CreatedDate: this.originalLabour.LeftPinky_CreatedDate,
    CreateBy: this.originalLabour.LeftPinky_CreateBy,
    ModifiedDate: this.originalLabour.LeftPinky_ModifiedDate,
    ModifiedBy: this.originalLabour.LeftPinky_ModifiedBy
  },
  {
    key: "RightThumb",
    oldValue: this.originalLabour.RightThumb,
    newValue: this.rightHandData.Thumb,
    id: this.originalLabour.RightThumb_ID,
    CreatedDate: this.originalLabour.RightThumb_CreatedDate,
    CreateBy: this.originalLabour.RightThumb_CreateBy,
    ModifiedDate: this.originalLabour.RightThumb_ModifiedDate,
    ModifiedBy: this.originalLabour.RightThumb_ModifiedBy
  },
  {
    key: "RightIndex",
    oldValue: this.originalLabour.RightIndex,
    newValue: this.rightHandData.Index,
    id: this.originalLabour.RightIndex_ID,
    CreatedDate: this.originalLabour.RightIndex_CreatedDate,
    CreateBy: this.originalLabour.RightIndex_CreateBy,
    ModifiedDate: this.originalLabour.RightIndex_ModifiedDate,
    ModifiedBy: this.originalLabour.RightIndex_ModifiedBy
  },
  {
    key: "RightMiddle",
    oldValue: this.originalLabour.RightMiddle,
    newValue: this.rightHandData.Middle,
    id: this.originalLabour.RightMiddle_ID,
    CreatedDate: this.originalLabour.RightMiddle_CreatedDate,
    CreateBy: this.originalLabour.RightMiddle_CreateBy,
    ModifiedDate: this.originalLabour.RightMiddle_ModifiedDate,
    ModifiedBy: this.originalLabour.RightMiddle_ModifiedBy
  },
  {
    key: "RightRing",
    oldValue: this.originalLabour.RightRing,
    newValue: this.rightHandData.Ring,
    id: this.originalLabour.RightRing_ID,
    CreatedDate: this.originalLabour.RightRing_CreatedDate,
    CreateBy: this.originalLabour.RightRing_CreateBy,
    ModifiedDate: this.originalLabour.RightRing_ModifiedDate,
    ModifiedBy: this.originalLabour.RightRing_ModifiedBy
  },
  {
    key: "RightPinky",
    oldValue: this.originalLabour.RightPinky,
    newValue: this.rightHandData.Pinky,
    id: this.originalLabour.RightPinky_ID,
    CreatedDate: this.originalLabour.RightPinky_CreatedDate,
    CreateBy: this.originalLabour.RightPinky_CreateBy,
    ModifiedDate: this.originalLabour.RightPinky_ModifiedDate,
    ModifiedBy: this.originalLabour.RightPinky_ModifiedBy
  }
];
    const documentForeignKey = "4E3A518F-CAF3-4938-A2B0-7C9D2660F85A";
    payload[documentForeignKey] = [];
  //   fieldsToCompare.forEach(field => {
  //   console.log("Checking =>", field.key, "| OldValue =>", field.oldValue, "| NewValue =>", field.newValue, "| ID =>", field.id);
    
  //   const isBase64 = field.newValue && typeof field.newValue === "string" && field.newValue.startsWith("data:image");
    
  //   // Only process if the value has changed AND it's a base64 image
  //   if (field.oldValue !== field.newValue && isBase64) {
      
  //     // Extract base64 data and determine file extension
  //     const base64Parts = field.newValue.split(";base64,");
  //     const mimeType = base64Parts[0].split(":")[1]; // e.g., "image/png", "image/jpeg"
  //     const base64Only = base64Parts[1];
      
  //     // Get file extension from MIME type
  //     let fileExtension = "png"; // default
  //     if (mimeType === "image/jpeg" || mimeType === "image/jpg") {
  //       fileExtension = "jpg";
  //     } else if (mimeType === "image/png") {
  //       fileExtension = "png";
  //     }

  //     if (!base64Only || base64Only.trim().length < 20) {
  //       console.warn("Skipping invalid base64 image for", field.key);
  //       return;
  //     }

  //     const base64SizeKB = Math.round((base64Only.length * 3) / 4000) + " KB";
  //     const createdDate = this.selectedLabour.CreatedDate || new Date().toISOString().replace("T", " ").substring(0, 19);
      
  //     const documentPayload: any = {
  //       Referance_Code: this.selectedLabour.Labour_Code || null,
  //       RefTypeMasterList_Code: "309",
  //       DocumentTypeMasterList_Code: "106",
  //       ParentRootFolder: "Documents\\Photos\\LabourPhotos\\",
  //       UploadFileName: `${this.selectedLabour.Labour_Code}_${field.key}.${fileExtension}`,
  //       Size: base64SizeKB,
  //       Page_Code: 192,
  //       CreatedDate: createdDate,
  //       CreateBy: GLOBAL.USER_ID,
  //       ModifiedDate: new Date().toISOString().replace("T", " ").substring(0, 19),
  //       ModifiedBy: GLOBAL.USER_ID,
  //       IsActive: 1,
  //       IsDelete: 0,
  //       IsSync: 0,
  //       Document: base64Only  // Only BASE64 string, no prefix
  //     };

  //     // If ID exists, include it for update; otherwise, it will be an insert
  //     if (field.id) {
  //       documentPayload.ID = field.id;
  //     } else {
  //       documentPayload.ID = "(SELECT @Id)";
  //       documentPayload.Sys_Code = "(SELECT 'OFF-' + CONVERT(VARCHAR(50), @Id))";
  //     }

  //     payload[documentForeignKey].push(documentPayload);
  //   }
  // });
  // // Remove document key if no images were changed
  // if (payload[documentForeignKey].length === 0) {
  //   delete payload[documentForeignKey];
  // }

    fieldsToCompare.forEach(field => {
  console.log("Checking =>", field.key, "| NewValue =>", field.newValue);
  
  const isBase64 = field.newValue && typeof field.newValue === "string" && field.newValue.startsWith("data:image");
  
  if (field.oldValue !== field.newValue && isBase64) {
      
      const base64Only = field.newValue.split(",")[1];   // remove prefix

      if (!base64Only || base64Only.trim().length < 20) {
          console.warn("Skipping invalid base64 image for", field.key);
          return;
      }

      const base64SizeKB = Math.round((field.newValue.length * 3) / 4000) + " KB";
      const getISTTimestamp = () => {
  return new Date(new Date().getTime() + (5.5 * 60 * 60 * 1000))
    .toISOString()
    .replace("T", " ")
    .substring(0, 19);
};
      // const createdDate = this.selectedLabour.CreatedDate;
      if (field.id) {
  // UPDATE operation - ID exists
  payload[documentForeignKey].push({
    ID: {
      OldValue: field.id,
      NewValue: field.id
    },
    Referance_Code: this.selectedLabour.Labour_Code || null,
    RefTypeMasterList_Code: "309",
    DocumentTypeMasterList_Code: "106",
    ParentRootFolder: "Documents\\Photos\\LabourPhotos\\",
    UploadFileName: `${this.selectedLabour.Labour_Code}_${field.key}.png`,
    Size: base64SizeKB,
    Page_Code: 192,
    CreatedDate: field.CreatedDate || getISTTimestamp(), // Use existing CreatedDate for updates
    CreateBy: field.CreateBy || GLOBAL.USER_ID, // Use existing CreateBy for updates
    ModifiedDate: {
      OldValue: field.ModifiedDate,
      NewValue: getISTTimestamp()
    },
    ModifiedBy: {
      OldValue: field.ModifiedBy,
      NewValue: GLOBAL.USER_ID
    },
    IsActive: 1,
    IsDelete: 0,
    IsSync: 0,
    Document: {
      OldValue: field.oldValue || null,
      NewValue: base64Only
    }
  });
} else {
  // INSERT operation - ID is null
  payload[documentForeignKey].push({
    ID: null, // Keep it as null, not `field.id || null`
    Referance_Code: this.selectedLabour.Labour_Code || null,
    RefTypeMasterList_Code: "309",
    DocumentTypeMasterList_Code: "106",
    ParentRootFolder: "Documents\\Photos\\LabourPhotos\\",
    UploadFileName: `${this.selectedLabour.Labour_Code}_${field.key}.png`,
    Size: base64SizeKB,
    Page_Code: 192,
    CreatedDate: getISTTimestamp(),
    CreateBy: GLOBAL.USER_ID,
    ModifiedDate: getISTTimestamp(),
    ModifiedBy: GLOBAL.USER_ID,
    IsActive: 1,
    IsDelete: 0,
    IsSync: 0,
    Document: base64Only // Only base64 string for new records
  });
}
    }
  });
    const foreignKeyPlantRelation = "7C40046B-58DF-48B8-A365-994F1A15365A";
    payload[foreignKeyPlantRelation] = payload[foreignKeyPlantRelation] || {};

    const formValue = this.labourForm.value;

    let levelID2: number | null = null;
    for (const plant of this.sectionTreeList) {
      if (plant.Values) {
        for (const unit of plant.Values) {
          if (unit.Values) {
            for (const department of unit.Values) {
              if (department.Values) {
                for (const section1 of department.Values) {
                  if (section1.Values) {
                    for (const section2 of section1.Values) {
                      if (section2.Values) {
                        for (const section3 of section2.Values) {
                          if (section3.Sectioncode2 == formValue.Section_Code2) {
                            levelID2 = section3.LevelID2;
                            break;
                          }
                        }
                      }
                      if (levelID2 !== null) break;
                    }
                  }
                  if (levelID2 !== null) break;
                }
              }
              if (levelID2 !== null) break;
            }
          }
          if (levelID2 !== null) break;
        }
      }
    }

    const fieldsToCompareNew = [
      { key: "ESICWageCriteria", oldValue: this.selectedLabour.ESICWageCriteria == true ? 1 : 0, newValue: formValue.ESICWageCriteria },
      { key: "Plant_Code", oldValue: this.selectedLabour.Plant_Code, newValue: formValue.Plant_Code },
      { key: "Skill_Code", oldValue: this.selectedLabour.Skill_Code, newValue: formValue.Skill_Code },
      { key: "LabourDemandTypeMasterItem_Code", oldValue: this.selectedLabour.LabourDemandTypeMasterItem_Code, newValue: formValue.LabourDemandTypeMasterItem_Code },
      { key: "CategoryMIL_Code", oldValue: this.selectedLabour.CategoryMIL_Code, newValue: formValue.CategoryMIL_Code },
      { key: "WorkCategoryMIT_Code", oldValue: this.selectedLabour.WorkCategoryMIT_Code, newValue: formValue.WorkCategoryMIT_Code },
      { key: "SectionPlant_ID", oldValue: this.selectedLabour.LevelID2, newValue: levelID2 },
      { key: "UnitRelationId", oldValue: this.selectedLabour.Departmentcode0, newValue: formValue.department }
    ];

    payload[foreignKeyPlantRelation]["GatePassRequest_Code"] = {
      OldValue: this.selectedLabour.GatePassRequest_Code,
      NewValue: this.selectedLabour.GatePassRequest_Code,
    };

    payload[foreignKeyPlantRelation]["Labour_Code"] = {
      OldValue: this.originalLabour.Labour_Code,
      NewValue: this.originalLabour.Labour_Code,
    };


    fieldsToCompareNew.forEach((field) => {
      if (field.key !== "GatePassRequest_Code" && field.key !== "Labour_Code" && field.oldValue !== field.newValue) {
        payload[foreignKeyPlantRelation][field.key] = {
          OldValue: field.oldValue,
          NewValue: field.newValue,
        };
      }
    });

    if (Object.keys(payload[foreignKeyPlantRelation]).length === 2 && payload[foreignKeyPlantRelation].GatePassRequest_Code && payload[foreignKeyPlantRelation].Labour_Code) {
      console.log('Deleting payload[foreignKeyPlantRelation] as it only contains GatePassRequest_Code');
      delete payload[foreignKeyPlantRelation];
    }

    const validityForeignKey = "BCE6B8B2-03F5-4ED5-804E-9BB8D7730D08";
    const worksiteForeignKey = "3CBA56A1-FE3A-4534-92C6-53E095C1B2F8";
    payload[validityForeignKey] = payload[validityForeignKey] || [];
    payload[worksiteForeignKey] = payload[worksiteForeignKey] || [];
    const validityPeriodList = Array.isArray(this.labourForm.value.ValidityPeriod_Code)
      ? this.labourForm.value.ValidityPeriod_Code
      : [this.labourForm.value.ValidityPeriod_Code];

    const selectedValidityPeriodsRaw = this.selectedLabour.ValidityPeriord;
    const selectedValidityPeriods = typeof selectedValidityPeriodsRaw === 'string'
      ? selectedValidityPeriodsRaw.split(',').map(vp => Number(vp.trim()))
      : Array.isArray(selectedValidityPeriodsRaw)
        ? selectedValidityPeriodsRaw.map(Number)
        : selectedValidityPeriodsRaw
          ? [Number(selectedValidityPeriodsRaw)]
          : [];

    const unmatchedValidityPeriods = selectedValidityPeriods.filter(vp => !validityPeriodList.includes(vp));
    unmatchedValidityPeriods.forEach(vp => {
      payload[validityForeignKey].push({
        GatePassRequest_Code: {
          OldValue: this.selectedLabour.GatePassRequest_Code,
          NewValue: this.selectedLabour.GatePassRequest_Code
        },
        ID: {
          OldValue: vp,
          NewValue: vp
        },
        IsDelete: {
          OldValue: 0,
          NewValue: 1
        }
      });
    });

    if (!selectedValidityPeriods.some(vp => validityPeriodList.includes(vp))) {
      payload[validityForeignKey].push({
        ID: "(SELECT @Id)",
        Sys_Code: "(SELECT 'OFF-' + CONVERT( VARCHAR(50), @Id))",
        GatePassRequest_Code: this.selectedLabour.GatePassRequest_Code,
        WorksiteMasterItemList_Code: validityPeriodList[0],
        CreateBy: GLOBAL.USER_ID,
        ModifiedBy: GLOBAL.USER_ID,
        IsActive: 1,
        IsDelete: 0,
        IsSync: 0
      });
    }

    const worksiteList = this.labourForm.value.WorksiteMasterItemList_Code;

    if (worksiteList !== Number(this.selectedLabour.WorkSite)) {
      payload[worksiteForeignKey].push({
        ID: "(SELECT @Id)",
        Sys_Code: "(SELECT 'OFF-' + CONVERT( VARCHAR(50), @Id))",
        GatePassRequest_Code: this.selectedLabour.GatePassRequest_Code,
        WorkSiteCategory_Code: worksiteList,
        CreateBy: GLOBAL.USER_ID,
        ModifiedBy: GLOBAL.USER_ID,
        IsActive: 1,
        IsDelete: 0,
        IsSync: 0
      });

      payload[worksiteForeignKey].push({
        GatePassRequest_Code: {
          OldValue: this.selectedLabour.GatePassRequest_Code,
          NewValue: this.selectedLabour.GatePassRequest_Code
        },
        ID: {
          OldValue: this.selectedLabour.WorkSite,
          NewValue: this.selectedLabour.WorkSite
        },
        IsDelete: {
          OldValue: 0,
          NewValue: 1
        }
      });
    }

    console.log("Generated Payload:", JSON.stringify(payload, null, 2));


    if (payload[worksiteForeignKey].length === 0) {
      delete payload[worksiteForeignKey];
    }

    if (Object.keys(payload[foreignKey]).length === 1 && payload[foreignKey].Labour_Code) {
      console.log('Deleting payload[foreignKey] as it only contains Labour_Code');
      delete payload[foreignKey];
    }

    if (payload[validityForeignKey].length === 0) {
      delete payload[validityForeignKey];
    }
    console.log('====================================');
    console.log("Payload",payload);
    console.log('====================================');
    this.labourService.updateProfilePhotoAndFingers(payload).subscribe((response) => {
      console.log("Payload sent successfully:", response);
      error: (err) => console.error("Error in IUDCommon:", err)
    });
    this.uploadDocuments();
    this.onUploadLabourPhoto();
    this.closeModal();
  }

  uploadDocuments() {
    if (this.uploadedFiles.length) {
      const DocumentImageMasterViewModals: any = [];
      this.uploadedFiles.forEach((file) => {
        if (file.isUploaded) {
          DocumentImageMasterViewModals.push({
            ID: file.ID,
            DocumentTypeMasterList_Code: file.documentTypeCode,
          });
        } else {
          DocumentImageMasterViewModals.push({
            DocumentTypeMasterList_Code: file.documentTypeCode,
          });
        }
      });
    }
    if (this.uploadedFiles && this.uploadedFiles.length > 0) {
      if (this.selectedLabour.Labour_Code) {
        this.fileUploadService.uploadFiles(
          this.uploadedFiles,
          this.selectedLabour,
          GLOBAL.APIS.CONTRACTOR_MANAGEMENT.UPLOAD_LABOUR_DOC
        ).subscribe((res) => { });
      }
    }
  }

  onFilesChanged(newFiles: any) {
    const set = new Set(
      newFiles.filter((item) => {
        if (item.ID) {
          return item.ID;
        }
      })
    );
    const result = [];

    for (const item of this.copyUploadedFiles) {
      if (!set.has(item.ID)) {
        result.push(item);
      }
    }
  }
  base64ToFile(data, filename) {
    const arr = data.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }
  onUploadLabourPhoto() {
    let file: File | null = null;

    if (this.savedCroppedImage.startsWith('data:image')) {
      file = this.base64ToFile(
        this.savedCroppedImage,
        `${this.selectedLabour.Labour_Code}.png`
      );
    }
    
    // 🚫 No API call if photo not changed
    if (!file) {
      return;
    }
    if (file) {
      this.labourService.uploadLabourPhoto(
        file,
        this.selectedLabour.Labour_Code,
        GLOBAL.APIS.CONTRACTOR_MANAGEMENT.UPLOAD_LABOUR_PHOTO
      ).subscribe({
        error: (err) => {
          console.error("Photo upload failed:", err);
          this.logHelperService.logError({
            message: "Photo upload failed. Please try again.",
          });
        }
      });
    }
    // const formData = new FormData();
    // formData.append('User_Code', this.selectedLabour.Labour_Code);
    // formData.append('Photo', file);
    // formData.append('UserID', GLOBAL.USER_ID);
    // const reqObj = {
    //   User_Code: this.selectedLabour.Labour_Code,
    //   Photo: file,
    //   UserID: GLOBAL.USER_ID,
    // };
    // console.log("reqObj",formData)
    // this.labourService.updateProfilePhoto(formData).subscribe();
  }
  // onUploadLabourPhoto() {
  //   const reqObj = {
  //     User_Code: this.selectedLabour.Labour_Code,
  //     Photo: this.savedCroppedImage,
  //     UserID: GLOBAL.USER_ID,
  //   };
  //   this.labourService.updateProfilePhoto(reqObj).subscribe((response) => { });
  // }

  closeModal() {
    this.showModal = false;
    this.activeModal.close();
    this.clearForm();
  }

  clearForm() {
    this.plantList = [];
    this.unitList = [];
    this.departmentList = [];
    this.sectionList = [];
    this.section1List = [];
    this.section2List = [];
    this.leftFinger = "";
    this.rightFinger = "";
    this.photoFile = null;
    this.leftFingerFile = null;
    this.rightFingerFile = null;
  }
}
